import i18next from 'i18next';

import { isBetaUser, userHasRoleInpulse } from '@commons/utils/roles';

export const AGENT = {
  getText: () => i18next.t('FEATURE.AGENT.AGENT'),
  path: '/agent',
  icon: '/images/inpulse/agent-black-small.svg',
  isVisible: ({ user, userRights }) => userHasRoleInpulse(user) || isBetaUser(userRights, '/agent'),
};
